import { Badge, Group, Stack, Text } from "@mantine/core";
import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { JournalErrorAlert } from "./JournalErrorAlert";

export const RuleEngineCrossStepTransferredFragment = graphql(`
  fragment RuleEngineCrossStepTransferredFields on RuleEngineCrossStepTransferredPayload {
    __typename
    sourceStepId
    targetStepId
    dataSource
    keyCount
    firstKeySamples
    engineTiming {
      conditionEvalMs
      actionExecMs
      totalMs
    }
    error {
      code
      message
      hint
      stackHint
    }
  }
`);

interface Props {
  data: FragmentOf<typeof RuleEngineCrossStepTransferredFragment>;
}

export function RuleEngineCrossStepTransferredPayload({ data }: Props) {
  const p = readFragment(RuleEngineCrossStepTransferredFragment, data);
  return (
    <Stack gap={4}>
      <Group gap="xs" wrap="wrap">
        <Badge color="cyan" size="xs">
          CROSS_STEP · {p.dataSource}
        </Badge>
        <Text size="xs">
          {p.sourceStepId.slice(0, 8)} → {p.targetStepId.slice(0, 8)}
        </Text>
        <Text size="xs" c="dimmed">
          {p.keyCount} key{p.keyCount === 1 ? "" : "s"} transferred
        </Text>
      </Group>
      {p.firstKeySamples.length > 0 && (
        <Text size="xs" c="dimmed">
          samples: {p.firstKeySamples.join(", ")}
        </Text>
      )}
      <Text size="xs" c="dimmed">
        timing: total {p.engineTiming.totalMs.toFixed(2)}ms
      </Text>
      {p.error && <JournalErrorAlert error={p.error} />}
    </Stack>
  );
}
